import { render, staticRenderFns } from "./BsWave.vue?vue&type=template&id=8a1ee6ee&"
import script from "./BsWave.vue?vue&type=script&lang=js&"
export * from "./BsWave.vue?vue&type=script&lang=js&"
import style0 from "./BsWave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports